import styled, { css } from 'styled-components';

import { TableCell, TableRow } from 'design-system/components/Table';
import { isHovered } from 'design-system/lib/pseudoClass';

export const StyledTableRow = styled(TableRow)<{ hoverable?: boolean }>`
  ${({ hoverable }) =>
    !hoverable &&
    css`
      &${isHovered} {
        background-color: ${({ theme }) => theme.color.background.primary};
      }
    `}
`;

export const StyledCheckboxCell = styled(TableCell)`
  width: 50px;
`;
